@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.innerIcon.innerIcon {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.dropdownRow {
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-weight:  hevo-toolkit-variables.$font-weight-medium;
}
.dropdownText {
  overflow: hidden;
  text-overflow: ellipsis;
}
.deleteIconColor {
  color:  hevo-toolkit-variables.$error !important;
}
.closeBtn {
  position: absolute;
  top:  hevo-toolkit-variables.$spacer * 0.75;
  right:  hevo-toolkit-variables.$spacer * 0.75;
  color:  hevo-toolkit-variables.$text-default;
  font-size:  hevo-toolkit-variables.$icon-size-base * 1.25;
}
.closeBtnSpan {
  font-size:  hevo-toolkit-variables.$font-size-body !important;
}
.bottomContainer {
  display: flex;
  justify-content: flex-end;
  border-top: solid  hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
}
.dialogContainer {
  width: 520px;
}
.dialogHeader {
  background: var(--surface-bg-color);
  top: 0;
  padding:  hevo-toolkit-variables.$spacer * 1.5;
  display: flex;
  align-items: center;
  z-index: 5;
}

.accountTypeDropdownRoot {
  flex: 1;
  border-right: solid  hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
}

.root {
  border: solid  hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  border-radius:  hevo-toolkit-variables.$border-radius-lg;

  &:hover {
    border-color:  hevo-toolkit-variables.$text-default;
  }
}

.focused {
  border-color:  hevo-toolkit-variables.$text-default;
}

.error {
  border-color:  hevo-toolkit-variables.$error !important;
}

.accountsLabel {
  position: absolute;
  padding: 0  hevo-toolkit-variables.$spacer * 0.5;
  z-index: 10;
  color:  hevo-toolkit-variables.$text-secondary;
  background-color:  hevo-toolkit-variables.$surface-bg;
  transform: translate( hevo-toolkit-variables.$spacer * 0.5, -1 *  hevo-toolkit-variables.$spacer * 0.5);
}

.labelFocused {
  color:  hevo-toolkit-variables.$text-default;
}
.asterisk {
  padding-left:  hevo-toolkit-variables.$spacer * 0.125;
}
.authAccountsDropDownRoot {
  flex: 3;
}
